module.exports = __webpack_public_path__ + "img/1716358184105-WhatsApp Image 2024-05-22 at 14.04.46.jpeg.f238aba0.webp";